import Vue from 'vue';
//引入公共样式
import '@/common/style/index.scss';
import '@xin/xin-ui/lib/xin-ui.css';
import '@xin/xin-statistic/lib/xin-statistic.css';
import '@xin/xin-workbench/lib/xin-workbench.common.css';
import './style/index.scss';
//公共拦截器
// 引入store
import store from './store/store';
// 引入路由
import router from './router/router';
//引导
import entryMixin from 'components/tour/entry-mixin';
import {XinIcon, XinLayout, XinLayoutVirtualService, XinMessage} from '@xin/xin-ui';
import VueCookies from 'vue-cookies'
import {PermissionRule} from '@/module/home/entities/permission-rule';
import trackerKeyMap from './tracker/tracker-key-map'
// sentry 监控工具
import {XrxsSentry} from '@xin/xin-tracker';
import {expDirective} from '@/common/utils/directives/exp';
import {postDirective} from '@/common/utils/directives/post';

import { XinCustomerServiceGpt } from "@xin/xin-ui";

// @ts-ignore
const layout = () => import('XinMf/XinLayout')
// @ts-ignore
const customerServiceGpt = () => import('XinMf/XinCustomerServiceGpt')


/**
 * 虚拟layout，无实际功能
 * 用于项目启动之前的导航展示，减少模块切换时的白屏时间
 * 数据均来自上次真实layout的数据缓存
 */
XinLayoutVirtualService.init()

/**
 * 重点：
 * 此步骤要加在 可以同时拿到  Vue，router，axios实例之后
 */
window.PRIVATE_DEPLOY !=='true' && new XrxsSentry({
  Vue: Vue,
  vueRouter: router,
  Http: Vue.prototype.$http,
  dsn: 'https://8b9a0dfc2bc8439a99f8033827f6c7c1@sentry-fe.xinrenxinshi.com/10',
  target: 'vue',
  // 需要上报错误是过滤的三方插件，我们cdn的路径都在/plugins下
  // 如需其他可以自行根据模块添加
  // 支持 字符串 和 正则
  threePartiesUrl: ['/plugins/']
}, 'unicorn-home').init();

Vue.use(VueCookies);
Vue.component('xin-icon', XinIcon);

// 绑定公共directive
expDirective(store);
postDirective();
// 替换$message为XinMessage
Vue.prototype.$message = XinMessage;

/**
 * 模块初始化
 */
Promise.all([window.XinInfra && window.XinInfra.XinModuleInit({
  store,
  router,
  layoutUrls: ['/index', '/appraisal/'],
  permissionConfig: {
    moduleIds: ['01', '02', '03', '04', '05', '07', '06','10','11','13','16'],
    ruleMap: PermissionRule
  },
  trackerConfig: {
    logProject: 'xrxs-online', //测试logProject：'xrxs-test'
    logstore: 'web-admin-pc',
    trackerKeyMap,
  }
}), layout(), customerServiceGpt()].map((p:any) => p.catch(() => true))).then((res:any) => {
  const [infraRes, layoutRes, customerServiceGptRes] = res;
  // xin-infra 有错误的情况下，阻塞
  // 单纯mf有问题，加载本地组件
  !infraRes && new Vue({
    el: '#home',
    mixins: [entryMixin],
    router,
    store,
    components: {
      XinLayout: layoutRes === true ? XinLayout : layoutRes.default,
      XinCustomerServiceGpt: customerServiceGptRes === true ? XinCustomerServiceGpt : customerServiceGptRes.default
    }
  });
  if(!infraRes && layoutRes === true) {
    if(Vue.prototype.XrxsSentry || window.XrxsSentry) {
      (Vue.prototype.XrxsSentry || window.XrxsSentry).fatal({
        error: 'Local-Layout::加载本地XinLayout',
        extra: {
          errorMessage: '加载本地XinLayout'
        },
        tags: {
          mf: '1',
          'mf-components': 'xin-layout'
        },
        errorType: '2',
        errorMessage: '加载本地XinLayout'
      });
    }
  }
});


